import { useNonTradingDaysCommon } from '@eih-netbroker/common';

export const useNonTradingDays = useNonTradingDaysCommon;
